import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Leaf, X, Mail } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SiteSettingsContext = createContext();
export const useSiteSettings = () => useContext(SiteSettingsContext);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState({ vacation_mode: false });
  const [noticeOpen, setNoticeOpen] = useState(false);

  useEffect(() => {
    let mounted = true;
    axios.get(`${API}/site/settings`)
      .then(r => { if (mounted) setSettings(r.data || { vacation_mode: false }); })
      .catch(() => { if (mounted) setSettings({ vacation_mode: false }); });
    return () => { mounted = false; };
  }, []);

  const vacationMode = !!settings.vacation_mode;
  const returnDate = settings.vacation_return_date || '';
  const title = settings.vacation_title || 'Siamo in ferie';
  const message = settings.vacation_message || '';

  // Returns true if the purchase action is blocked (and shows the notice)
  const guardPurchase = useCallback(() => {
    if (vacationMode) { setNoticeOpen(true); return true; }
    return false;
  }, [vacationMode]);

  return (
    <SiteSettingsContext.Provider value={{ vacationMode, returnDate, title, message, guardPurchase, openNotice: () => setNoticeOpen(true) }}>
      {children}
      {noticeOpen && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="vacation-notice-modal">
          <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={() => setNoticeOpen(false)} />
          <div className="relative z-10 w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 text-center" style={{ animation: 'vacpop .25s ease-out' }}>
            <button onClick={() => setNoticeOpen(false)} className="absolute top-4 right-4 text-essenya-text hover:text-essenya-ink" aria-label="Chiudi" data-testid="vacation-notice-close">
              <X size={20} strokeWidth={1.5} />
            </button>
            <div className="w-14 h-14 rounded-full bg-essenya-champagne flex items-center justify-center mx-auto mb-5">
              <Leaf size={26} strokeWidth={1.5} className="text-essenya-ink" />
            </div>
            <h2 className="font-display text-2xl md:text-3xl mb-3" data-testid="vacation-notice-title">{title}</h2>
            <p className="text-essenya-text mb-2">
              Gli ordini sono momentaneamente <strong>sospesi</strong>.
              {returnDate ? <> Riapriamo il <strong>{returnDate}</strong>.</> : null}
            </p>
            {message && <p className="text-essenya-text text-sm mb-6">{message}</p>}
            <button onClick={() => setNoticeOpen(false)} className="btn-primary w-full mb-4" data-testid="vacation-notice-ok">Ho capito</button>
            <a href="mailto:info@essenya.it" className="inline-flex items-center gap-1.5 text-sm text-essenya-text hover:text-essenya-ink transition-colors">
              <Mail size={14} strokeWidth={1.5} /> info@essenya.it
            </a>
          </div>
          <style>{`@keyframes vacpop{from{opacity:0;transform:translateY(12px) scale(.98)}to{opacity:1;transform:none}}`}</style>
        </div>
      )}
    </SiteSettingsContext.Provider>
  );
}
